import { EXTRALARGE, SMALL } from "shared/variables";
import { getDocByUID, getDocs } from "shared/prismic";
import { MaxWidth } from "components/MaxWidth";
import { Page } from "components/Page";
import { PageTitleWithLabel } from "components/PageTitleWithLabel";
import { SpacingSection } from "components/SpacingSection";
import { StudyGuideForm } from "components/StudyGuideForm";

const PAGE_TYPE = "course_detail";

export async function getStaticProps({ preview = null, previewData, params }) {
  const doc = await getDocByUID({
    previewData,
    uid: params.uid,
    type: PAGE_TYPE,
  });
  return { props: { doc, preview } };
}

export async function getStaticPaths() {
  const pages = await getDocs({ type: PAGE_TYPE });
  const paths = pages.map(({ uid }) => ({ params: { uid } }));
  return { paths, fallback: false };
}

const StudiegidsAanvragen = ({ doc, preview }) => {
  const { type, uid } = doc;
  const { hero_title, seo_title, seo_description, seo_image } = doc.data;

  return (
    <Page
      title={seo_title}
      description={seo_description}
      image={seo_image}
      preview={preview}
    >
      <SpacingSection size={EXTRALARGE}>
        <MaxWidth>
          <PageTitleWithLabel
            title="Studiegids aanvragen"
            label={hero_title?.replace(/\*/g, "")}
            link={{ type, uid }}
          />
          <SpacingSection size={SMALL}>
            <StudyGuideForm courseUid={doc.uid} />
          </SpacingSection>
        </MaxWidth>
      </SpacingSection>
    </Page>
  );
};

export default StudiegidsAanvragen;
